import { type ActivityUsageItem } from '../../api/index.js';

const MONTH_KEY_LENGTH = 7;

export function usageMonthKey(item: Pick<ActivityUsageItem, 'patientId' | 'day'>): string {
  return `${item.patientId}::${item.day.slice(0, MONTH_KEY_LENGTH)}`;
}

/** Estimated cost per patient per calendar month, summed across the models that ran. */
export function sumUsageByPatientMonth(items: ActivityUsageItem[]): Map<string, number> {
  const totals = new Map<string, number>();
  for (const item of items) {
    const key = usageMonthKey(item);
    totals.set(key, (totals.get(key) ?? 0) + item.costUsd);
  }
  return totals;
}
